// extracted by mini-css-extract-plugin
module.exports = {"login":"styles_login__hMDWE","icon":"styles_icon__2dr4L","other":"styles_other__vDjVU","submit":"styles_submit__hKQYL"};